// extracted by mini-css-extract-plugin
export default {"display-none":"g__display-none--dwF5L","u-pointer-cursor":"g__u-pointer-cursor--obSwF","new-mobile-header-content":"g__new-mobile-header-content--ILiV2"};